export function isNil(value) {
    return value === undefined || value === null || Number.isNaN(value);
}
export function isNilOrEmptyString(value) {
    return isNil(value) || value === '';
}
export function getDataTestId(componentTestId, propsDataTestId) {
    if (!propsDataTestId) {
        return componentTestId;
    }
    if (!componentTestId) {
        return propsDataTestId;
    }
    return `${propsDataTestId}-${componentTestId}`;
}
//# sourceMappingURL=utils.js.map